import { useMemo } from 'react';
import ReactEcharts from "echarts-for-react";
import styles from './survey-answers.module.css'
import AngryIcon from '../../../assets/logos/icons/bx_angry.png'
import SmileIcon from '../../../assets/logos/icons/bx_smile.png'
import NeutralIcon from '../../../assets/logos/icons/bx_neutral.png'
import SadIcon from '../../../assets/logos/icons/bx_sad.png'
import HappyIcon from '../../../assets/logos/icons/bx_happy.png'

const SCALE_TICKS = [
    { color: "#B4375D", icon: AngryIcon, name: 'Angry' },
    { color: "#F09529", icon: SadIcon, name: 'Sad' },
    { color: "#F2D82C", icon: NeutralIcon, name: 'Neutral' },
    { color: "#A9CD3B", icon: SmileIcon, name: 'Smile' },
    { color: "#26A623", icon: HappyIcon, name: 'Happy' },
]

const ScaleAnswers = (props) => {
    const { question } = props;
    const { name, order, data } = question;

    const option = useMemo(() => {
        if (!data || !data.length) return;

        let graphData = []
        for (const item of data) {
            graphData.push({
                value: item.count,
                itemStyle: {
                    color: SCALE_TICKS[item.rating - 1].color
                }
            })
        }

        const option = {
            grid: { right: 10, top: 10 },
            yAxis: { type: 'value' },
            xAxis: {
                type: 'category',
                data: SCALE_TICKS.map(t => t.name),
                axisLabel: {
                    formatter: function (value) {
                        return '{' + value + '| }';
                    },
                    rich: SCALE_TICKS.reduce((acc, { name, icon }) => {
                        acc[name] = {
                            height: 28,
                            align: 'center',
                            backgroundColor: {
                                image: icon
                            }
                        };
                        return acc;
                    }, {})
                }
            },
            series: [
                {
                    name: 'Total answers',
                    type: 'bar',
                    data: graphData
                }
            ],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    animation: false
                }
            },
        };
        return option;
    }, [data])

    return (
        <>
            <p className={styles['question-title']}>{order}. {name}</p>
            {
                option
                    ? <ReactEcharts option={option} />
                    : <p>N/D</p>
            }
        </>
    )
}

export default ScaleAnswers